import { Box } from 'src/design/atoms/Box';
import { Divider } from 'src/design/atoms/Divider';
import { Group } from 'src/design/atoms/Group';
import { Stack } from 'src/design/atoms/Stack';
import { Text } from 'src/design/atoms/Text';
import { BaseModal } from 'src/design/molecules/BaseModal';
import { BasicButton } from 'src/design/atoms/BasicButton';
import React from 'react';

import { CTCJobDto } from 'src/routes/CTC/ViewCTCJob/helpers';

interface ProjectTeamModalProps {
  opened: boolean;
  linkedJob: CTCJobDto | null;
  onClose: () => void;
}

export const ProjectTeamModal: React.FC<ProjectTeamModalProps> = ({
  opened,
  linkedJob,
  onClose,
}) => {
  return (
    <BaseModal opened={opened} onClose={onClose} title="Project Team" size="xl">
      {linkedJob && (
        <Stack gap={0}>
          {linkedJob?.team?.map((t) => {
            const user = t.user;
            const roles =
              user?.userOrganizationRole
                ?.map((r) => r.organizationRole?.name)
                .filter(Boolean)
                .join(', ') || '';
            const hasRoles = (user?.userOrganizationRole?.length ?? 0) > 0;
            return (
              <React.Fragment key={t.id}>
                <Box py="xs">
                  <Text fw={500}>{user?.fullName}</Text>
                  <Text size="sm" c="dimmed">
                    {hasRoles ? roles : 'No roles assigned'}
                  </Text>
                </Box>
                <Divider />
              </React.Fragment>
            );
          })}
        </Stack>
      )}
      <Group justify="flex-end" mt="md">
        <BasicButton onClick={onClose}>Close</BasicButton>
      </Group>
    </BaseModal>
  );
};
